<template>
  <v-dialog v-model="visible" width="40rem" persistent scrollable>
    <v-card v-if="is_loading">
      <v-skeleton-loader type="card, list-item@6" />
    </v-card>
    <template v-else>
      <v-card>
        <v-toolbar color="primary white--text" flat>
          <sabira_icon
            icon="email_invoice"
            class="mr-2"
            :strokewidth="3"
            fill="white"
          />
          <v-toolbar-title class="ml-1 text-wrap" style="line-height:1.3">
            {{ item.subject }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <div>
            {{ $moment(new Date(item.created_time)).format("DD.MM.YYYY.") }}
          </div>
        </v-toolbar>
        <v-card-text style="height: 30rem;" class="pa-6">
          <div v-html="item.message"></div>
        </v-card-text>
        <v-card-actions class="background">
          <v-btn text @click="close_dialog()">Odustani</v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
  export default {
    components: {
      sabira_icon: () => import("@/components/sabira_icon"),
    },
    props: {
      id: {
        type: Number,
        default: 0,
      },
    },
    data: () => ({
      is_loading: true,
      item: {
        id: 0,
        user_id: 0,
        subject: null,
        message: null,
        date_created: null,
        read_check: null,
      },
      visible: false,
    }),
    mounted() {
      this.visible = true;
    },
    watch: {
      visible: {
        handler() {
          if (this.id > 0) {
            this.get_item();
          } else {
            this.item = {
              id: 0,
              user_id: 0,
              subject: null,
              message: null,
              date_created: null,
              read_check: null,
            };
            this.is_loading = false;
          }
        },
        immediate: false,
      },
    },
    methods: {
      close_dialog() {
        if (this.read_check == 1) {
          this.$webpageEventBus.$emit("close_message");
        } else {
          this.save_item();
        }
      },
      get_item() {
        this.$http({
          method: "GET",
          url: "/get_messages/get_single_message/" + this.id,
        }).then((resp) => {
          this.item = resp.data.result[0];
          this.is_loading = false;
        });
      },
      save_item() {
        this.$http({
          method: "POST",
          url: "/message/update",
          data: this.item,
        })
          .then((resp) => {
            if (resp.status == 200) {
              this.$webpageEventBus.$emit("close_message");
              this.$webpageEventBus.$emit("reload_data");
              this.$webpageEventBus.$emit("new_message");
            } else {
              this.$webpageEventBus.$emit("show_status", {
                type: "error",
                message: resp.data.message,
                timeout: 4000,
              });
            }
          })
          .catch((e) => {
            this.$webpageEventBus.$emit("show_status", {
              type: "error",
              message: e,
              timeout: 4000,
            });
          });
      },
    },
  };
</script>

<style scoped>
  .master_grid {
    display: grid;
    grid-template-columns: 1fr;
    height: 100%;
    width: 100%;
  }

  .left_grid {
    color: white;
    display: grid;
    grid-template-rows: 1fr max-content;
    height: 100%;
  }
  .v-tooltip__content {
    color: black;
    opacity: 1;
  }
</style>
